import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AuntContainer from "./app/AuntContainer";

ReactDOM.render(
  <React.StrictMode>
    <AuntContainer/>
  </React.StrictMode>,
  document.getElementById('root')
);

